module.exports = __webpack_public_path__ + "img/camera.fc36e92d.svg";